export const server = "https://saiaqua.shop/api/v2";
export const backend_url = "https://saiaqua.shop";
